export default __webpack_public_path__ + "static/media/gd_4.241669fe.jpg";